import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 14,
  medium: 8,
  small: 8,
  xSmall: 6
};
const PauseIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement("path", { d: "M12 22V8H11V22H12Z", fill: "currentColor" }),
    /* @__PURE__ */ React.createElement("path", { d: "M19 22V8H18V22H19Z", fill: "currentColor" })
  );
};
PauseIcon.iconName = "PauseIcon";

export { PauseIcon };
